import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface RecipientInputProps {
  originalMessage: {
    sendBy: string;
  };
  styles: Record<string, string>;
}

const RecipientInput: FC<RecipientInputProps> = ({ originalMessage, styles }) => {
  const { t } = useTranslation();

  return (
    <FloatLabelInput
      label={t('messages.mailbox.recipient')}
      value={originalMessage.sendBy}
      className={styles['form-section']}
      inputClassName={styles['form-recipient']}
      disabled
    />
  );
};

export default RecipientInput;
